import { ActionIcon, CopyButton, Group, Text, Tooltip } from "@mantine/core";
import { IconCheck, IconCopy } from "@tabler/icons-react";

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** True when a value is a bare UUID (e.g. an order id leaked into a code field). */
export function isUuid(value: string | null | undefined): boolean {
  return !!value && UUID_RE.test(value.trim());
}

/** The human-readable order code, or null when only a UUID/empty is available.
 *  Legacy rows stored the order UUID in `orderNumber`; treat those as "no code". */
export function orderCodeOf(fee: { orderNumber: string | null; orderId: string }): string | null {
  return fee.orderNumber && !isUuid(fee.orderNumber) ? fee.orderNumber : null;
}

/** Order-number table cell: the human code as the primary value (or a muted
 *  short id when none exists), with the full order id tucked behind a copy
 *  button + tooltip so support can still reach it without it dominating. */
export function OrderRefCell({ orderNumber, orderId }: { orderNumber: string | null; orderId: string }) {
  const code = orderCodeOf({ orderNumber, orderId });
  return (
    <Group gap={4} wrap="nowrap">
      {code ? (
        <Text size="sm" fw={500} style={{ fontVariantNumeric: "tabular-nums" }}>{code}</Text>
      ) : (
        <Text size="sm" c="dimmed" style={{ fontVariantNumeric: "tabular-nums" }}>
          #{orderId.slice(0, 8)}
        </Text>
      )}
      <CopyButton value={orderId} timeout={1500}>
        {({ copied, copy }) => (
          <Tooltip label={copied ? "Хуулсан" : `Захиалгын ID: ${orderId}`} withArrow>
            <ActionIcon
              size="sm"
              variant="subtle"
              color={copied ? "teal" : "gray"}
              onClick={copy}
              aria-label="Захиалгын ID хуулах"
            >
              {copied ? <IconCheck size={14} /> : <IconCopy size={14} />}
            </ActionIcon>
          </Tooltip>
        )}
      </CopyButton>
    </Group>
  );
}
